import { Grid } from '@mui/material';
import { withStyles } from '@mui/styles';
import classnames from 'classnames';
import parse from 'html-react-parser';
import React from 'react';

import Header from 'Containers/header';
import supportImg from 'Images/support-white.svg';
import { useClientThemeData } from 'SharedComponents/hooks/useClientThemeData';

import * as styles from './support.module.css';

type SupportRow = {
    header: string;
    blurb1: string;
    blurb2?: string;
    blurb3?: string;
};

const muiStyles = () => ({
    grow: { flexGrow: 1 },
    shrink: {
        flexShrink: 1,
        flexBasis: 'auto'
    },
    wrapper: { height: '100%' },
    mainContent: {
        maxWidth: 'inherit',
        flexGrow: 1,
        flexBasis: 'auto'
    }
});

const Support: React.FunctionComponent<any> = () => {
    const clientInfo = useClientThemeData();

    const renderConfigurableRow = (row: SupportRow) => {
        return (
            <div
                className={styles.section}
                key={row.header}
            >
                <h2 className={styles.heading}>{row.header}</h2>
                <div className={styles.column}>
                    <p>{parse(row.blurb1)}</p>
                    {row.blurb2 ? <p>{parse(row.blurb2)}</p> : <p />}
                    {row.blurb3 ? <p>{parse(row.blurb3)}</p> : <p />}
                </div>
            </div>
        );
    };

    return (
        <Grid
            className={styles.root}
            container
            direction='column'
            spacing={0}
        >
            <Header />
            <Grid
                item
                xs={12}
            >
                {!process.env.STEALTH_MODE && (
                    <div className={styles.supportContainer}>
                        <div>
                            <div
                                className={styles.upperContainer}
                                id='upperContainer'
                            >
                                <img
                                    className={styles.supportImg}
                                    src={supportImg}
                                />
                                {clientInfo.support.configurablePage?.header?.blurb1 ? (
                                    <h1
                                        className={styles.contactTimeSection}
                                        id='blurb1Section'
                                    >
                                        {parse(clientInfo.support.configurablePage.header.blurb1)}
                                    </h1>
                                ) : (
                                    <h1
                                        className={styles.contactTimeSection}
                                        id='contactTimeSection'
                                    >
                                        Get Help from {clientInfo.names.clientName}<br />
                                        {clientInfo.support.contactInfo.contactTime || '24-Hour Client Services'}
                                    </h1>
                                )}
                                <table>
                                    <tbody>
                                        {clientInfo.support.contactInfo.phoneTollFree && (
                                            <tr>
                                                <td>Toll Free:</td>
                                                <td id='phoneTollFreeSection'>
                                                    <strong>
                                                        <a
                                                            className={styles.upperContainerLinks}
                                                            href={`tel:${clientInfo.support.contactInfo.phoneTollFree}`}
                                                            rel='noreferrer'
                                                            target='_blank'
                                                        >
                                                            {clientInfo.support.contactInfo.phoneTollFree}
                                                        </a>
                                                    </strong>
                                                </td>
                                            </tr>
                                        )}
                                        {clientInfo.support.contactInfo.phoneDirect && (
                                            <tr>
                                                <td>Direct:</td>
                                                <td id='phoneDirectSection'>
                                                    <strong>
                                                        <a
                                                            className={styles.upperContainerLinks}
                                                            href={`tel:${clientInfo.support.contactInfo.phoneDirect}`}
                                                            rel='noreferrer'
                                                            target='_blank'
                                                        >
                                                            {clientInfo.support.contactInfo.phoneDirect}
                                                        </a>
                                                    </strong>
                                                </td>
                                            </tr>
                                        )}
                                        <tr>
                                            <td>Email:</td>
                                            <td id='contactInfoSection'>
                                                <strong>
                                                    <a
                                                        className={styles.upperContainerLinks}
                                                        href={`mailto:${clientInfo.support.contactInfo.email}`}
                                                        rel='noreferrer'
                                                        target='_blank'
                                                    >
                                                        {clientInfo.support.contactInfo.email}
                                                    </a>
                                                </strong>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className={styles.below}>
                            {clientInfo.support.configurablePage?.body &&
                                clientInfo.support.configurablePage?.body.map((row) => renderConfigurableRow(row))}
                            {clientInfo.support.configurablePage?.footer && (
                                <div
                                    className={classnames(styles.section, styles.lastSection)}
                                    id='footerSection'
                                >
                                    {clientInfo.support.configurablePage?.footer?.blurb1 && (
                                        <p>{parse(clientInfo.support.configurablePage.footer.blurb1)}</p>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </Grid>
        </Grid>
    );
};

export default withStyles(muiStyles)(Support);